import { createSelector } from 'reselect'

const propertySearchState = (state: any) => state.ui.propertySearch

export const getCurrentSearchQuery = createSelector(propertySearchState, propertySearch => propertySearch.query)
